import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import type { Campaign } from 'Campaign-Types';

import campaigns from './campaignData';

export const campaignData = createReducer(campaigns as Array<Campaign>);

const campaignReducer = combineReducers({
  campaignData,
});

export default campaignReducer;
export type CampaignState = ReturnType<typeof campaignReducer>;
